import React, { useState, useEffect } from 'react'
import Button from '../ui/button'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'
import './CookieConsentBanner.sass'

export default function CookieConsentBanner() {
    const [t] = useTranslation()
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent)
        const consent = Cookies.get('cookieConsent')
        if (!consent && !isBot) setVisible(true)
    }, [])

    const setConsent = (value: string) => {
        const cookieDuration = value === 'accepted' ? 365 : 7
        document.cookie = Cookies.set('cookieConsent', value, { expires: cookieDuration })
        setVisible(false)
        if (value === 'accepted') window.location.reload()
    }

    if (!visible) return null

    return (
        <div className={'cookieConsentBanner'}>
            <div className={'desktopCookieButton'}>
                <Button onClick={() => setConsent('rejected')} label={t('Refuse')} />
            </div>
            <div>{t('This site uses cookies for statistical purposes only.')}</div>

            <div className={'desktopCookieButton'}>
                <Button onClick={() => setConsent('accepted')} label={t('Accept')} />
            </div>
            <div className={'cookieButtons mobileCookieButtons'}>
                <Button onClick={() => setConsent('rejected')} label={t('Reject')} />
                <Button onClick={() => setConsent('accepted')} label={t('Accept')} />
            </div>
        </div>
    )
}
